import { Cell, Pie, PieChart as RechartsPieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { CHART_COLORS, chartTooltipStyle, formatChartCurrency } from './chartTheme';

export interface DonutSlice {
  name: string;
  value: number;
  color?: string;
}

interface DonutChartProps {
  data: DonutSlice[];
  height?: number;
  /** Pixel or percent string (e.g. "70%") — percent scales with container */
  innerRadius?: number | string;
  outerRadius?: number | string;
  valueFormatter?: (value: number) => string;
}

function DonutChart({
  data,
  height = 240,
  // Percent radii scale with the container so the ring is never clipped.
  innerRadius = '52%',
  outerRadius = '78%',
  valueFormatter = formatChartCurrency,
}: DonutChartProps) {
  return (
    <div className="h-full w-full min-w-0 overflow-visible" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsPieChart margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={2}
            animationDuration={650}
            isAnimationActive
          >
            {data.map((entry, index) => (
              <Cell key={entry.name} fill={entry.color ?? CHART_COLORS[index % CHART_COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={chartTooltipStyle}
            formatter={(value: number) => valueFormatter(value)}
          />
        </RechartsPieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default DonutChart;
